import React from 'react';
import Layout from '../layouts/two';
import { Link } from 'react-router';
import Title from '../partials/title';
import TournamentLink from './partials/tournament';
import ScrollAnimation from 'react-animate-on-scroll';
import SubNav from './partials/sub_nav';
import ESPN from './partials/espn';
import _ from 'lodash';
import Logo from '../layouts/logo';
import { Animated } from 'react-animated-css';
import { generateRandomId, formatPriceInt } from '../../helpers';

class Tournament extends React.Component {
    state = {
        tournament: null,
        bootstrapped: false
    }
    componentWillMount() {
        const { tournaments, upcoming, past, params, tournamentsActions } = this.props, { id } = params;
        if ((tournaments && tournaments.length && _.find(tournaments, t => parseInt(t.id, 10) === parseInt(id, 10)))) {
            this.setState({ tournament: _.find(tournaments, t => parseInt(t.id, 10) === parseInt(id, 10)) });
        } else if ((upcoming && upcoming.length && _.find(upcoming, t => parseInt(t.id, 10) === parseInt(id, 10)))) {
            this.setState({ tournament: _.find(upcoming, t => parseInt(t.id, 10) === parseInt(id, 10)) });
        } else if ((past && past.length && _.find(past, t => parseInt(t.id, 10) === parseInt(id, 10)))) {
            this.setState({ tournament: _.find(past, t => parseInt(t.id, 10) === parseInt(id, 10)) });
        }
        tournamentsActions.fetch(id);
    }
    componentWillReceiveProps = nextProps => {
        const { tournament, tournamentsActions } = nextProps;
        if (!this.state.tournament || !this.state.tournament.id || !this.state.bootstrapped)
            this.setState({ tournament: tournament || this.state.tournament, bootstrapped: true }, () => {
                tournamentsActions.fetchUpcoming();
            });
    }
    render() {
        const { params } = this.props, { id } = params, { tournament = {} } = this.state, { Medal = {} } = tournament || {};
        let bi = (tournament && tournament.IdMedal) ? `/images/medals/${tournament.IdMedal}.jpg` : "/images/backgrounds/edoardo-busti-413350-unsplash.jpg";
        const genid = generateRandomId(5);

        if (tournament) {
            return <Layout hero={450} medal={Medal} nbs="tournaments" title={(tournament && tournament.id) ? `TOURNAMENT` : ``} bi={bi}>
                <section>
                    {tournament && tournament.id && (
                        <div id="tournament" style={{ marginTop: '-4.5em' }}>
                            <div className="w3-container w3-content">
                                <div className="d-flex flex-column">
                                    <ul className="no-margin no-padding" style={{ listStyle: 'none' }}>
                                        <ScrollAnimation animateIn="fadeIn" animateOnce={true} component="li"
                                            className="w3-card margin-top" style={{ backgroundColor: 'white', borderRadius: 4 }}>
                                            <TournamentLink hideLink={true} tournament={tournament} />
                                        </ScrollAnimation>
                                    </ul>
                                </div>
                            </div>
                            {tournament && <div className="w3-container w3-content">
                                <SubNav id={id} key={genid} current={1} tournament={tournament} />

                                {/* Rates */}
                                {tournament.Rates && tournament.Rates.length > 0 && <div className="d-flex row-column justify-content-center margin-top">
                                    {tournament.Rates.map((rate, index) => <Animated key={index} animationIn="fadeIn" className="w3-card hind p-2 bg-white d-flex flex-column justify-content-start align-self-center margin-bottom-half margin-left-half margin-right-half" style={{ width: 140, height: 100, borderRadius: 5 }}>
                                        <span className="black font-20 align-self-center toBold">{formatPriceInt(rate.Rate * 100)}</span>
                                        <span className="black font-12 align-self-center">{rate.Name}</span>
                                        <span className="black font-8 align-self-center">{rate.Dates}</span>
                                    </Animated>)}
                                </div>}

                                <Animated animationIn="fadeIn" animationInDelay={900} className={`d-flex flex-row justify-content-center margin-top-double ${!tournament.GivesShirt ? 'margin-bottom-double' : ''}`}>
                                    {(!tournament.Affiliate || tournament.Affiliate.UseSportslogic) && <a href='https://sl.sportslogic.net' target="_blank" rel="noopener noreferrer" className="btn-red bg-red text-center white" style={{ width: 200, lineHeight: '1.9' }}>Register</a>}
                                    {(tournament.Affiliate && tournament.Affiliate.UseSportslogic) && <div style={{ width: 50 }} />}
                                    {tournament.Affiliate && <a href={tournament.Affiliate.Url} target="_blank" rel="noopener noreferrer" className="btn-transparent text-center white" style={{ width: 200, lineHeight: '1.9' }}>Tournament's Website</a>}
                                </Animated>

                                {!tournament.Affiliate && <Animated animationIn="fadeInLeft" animationInDelay={1100} className="d-flex flex-column justify-content-center my-4">
                                    <span className="white hind bg-black py-2 px-3 align-self-center text-center">Minimum 4 Game(s) - Tournament T-Shirt (Only for Regionals and Nationals)</span>
                                    <span className="white font-10 align-self-center text-center mt-2">Other events will have different giveaways</span>
                                </Animated>}



                            </div>}
                            {tournament && tournament.Notes && tournament.ShowNotes && <div className="w3-white">
                                <ScrollAnimation animateIn="fadeIn" animateOnce={true} className="w3-content w3-container d-flex flex-row" style={{ paddingTop: '4em', paddingBottom: '4em' }}>
                                    <div className="w-100">
                                        <Title text={`${tournament.Affiliate ? 'Information' : 'Overview'}`} />
                                        <p className="black margin-top line1 font-14" dangerouslySetInnerHTML={{ __html: tournament.Notes }} ></p>
                                    </div>
                                </ScrollAnimation>
                            </div>}
                            {tournament && tournament.Hotels && tournament.Hotels.length > 0 && <div className="w3-white">
                                <ScrollAnimation animateIn="fadeIn" animateOnce={true} className="w3-content w3-container d-flex flex-row" style={{ paddingTop: '4em', paddingBottom: '4em' }}>
                                    <div className="w-100">
                                        {/*<h2 className="black text-center anton">Hotels / Attractions</h2>*/}
                                        <Title text={`Hotels / Attractions`} />
                                        <p className="hind black margin-top">Challenge Sports works to get you the best Rates!</p>
                                        <Link to={`/hotels/${id}`} className="btn btn-info">View Options</Link>
                                    </div>
                                </ScrollAnimation>
                            </div>}
                            {tournament && Medal.id && <div className="w3-black" id="medal">
                                <ScrollAnimation animateIn="fadeIn" animateOnce={true} className="w3-content w3-container d-flex flex-row" style={{ paddingTop: '4em', paddingBottom: '4em' }}>
                                    <div className="w-100">
                                        <h2 className="hero-text anton text-left no-padding no-margin toUpper">{Medal.Name}</h2>
                                        <p className="hind white">{Medal.Description}</p>
                                    </div>
                                    <div style={{ width: 20 }} />
                                    <div style={{ width: 300 }} className="align-self-center">
                                        <img alt="" src={Medal.Medal} className="w-100" />
                                    </div>
                                </ScrollAnimation>
                            </div>}
                            {tournament && tournament.IsESPN && <ESPN tournament={tournament} />}
                        </div>)}
                </section>
            </Layout>
        } else {
            return <div className="bg-blackish h-100 w-100 d-flex flex-column">
                <div style={{ height: 200 }} />
                <Logo className="align-self-middle" />
                <span className="align-self-center font-10 gray">Loading</span>
            </div>
        }
    }
}

export default Tournament;



// WEBPACK FOOTER //
// ./src/components/tournaments/tournament.js